const styles = () => ({
  displayNone: {
    display: 'none',
  },
  previewPage: {
    background: '#717171',
    // minHeight: '940px',
    // height: '100%',
    width: '100%',
  },
  previewPageMobile: {
    background: '#717171',
    height: '120%',
  },
  contentClass: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
    paddingTop: '0',
    minHeight: '100vh',
  },
});

export default styles;
